/**
 * Short UI sounds for bracelet designer (add / remove bead).
 */
(function (global) {
  const MIN_INTERVAL_MS = 55;
  let addAudio = null;
  let removeAudio = null;
  let unlocked = false;
  let lastAddAt = 0;
  let lastRemoveAt = 0;

  function prefersQuiet() {
    try {
      return global.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;
    } catch {
      return false;
    }
  }

  function preload(url, volume) {
    if (!url) return null;
    const audio = new Audio(url);
    audio.preload = 'auto';
    audio.volume = volume;
    return audio;
  }

  function unlock() {
    if (unlocked) return;
    unlocked = true;
    for (const audio of [addAudio, removeAudio]) {
      if (!audio) continue;
      const prevVolume = audio.volume;
      audio.volume = 0;
      const p = audio.play();
      if (p && typeof p.then === 'function') {
        p.then(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.volume = prevVolume;
        }).catch(() => {
          audio.volume = prevVolume;
        });
      } else {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = prevVolume;
      }
    }
  }

  function play(audio, kind) {
    if (prefersQuiet() || !audio) return;
    unlock();
    const now = Date.now();
    const lastAt = kind === 'add' ? lastAddAt : lastRemoveAt;
    if (now - lastAt < MIN_INTERVAL_MS) return;
    if (kind === 'add') lastAddAt = now;
    else lastRemoveAt = now;
    try {
      audio.currentTime = 0;
      const p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch {
      /* ignore */
    }
  }

  function init(urls) {
    if (!urls || prefersQuiet()) return;
    addAudio = preload(urls.add, 0.42);
    removeAudio = preload(urls.remove, 0.72);
    global.addEventListener('pointerdown', unlock, { once: true, passive: true });
    global.addEventListener('keydown', unlock, { once: true, passive: true });
  }

  global.DesignerSounds = {
    init,
    playAdd() {
      play(addAudio, 'add');
    },
    playRemove() {
      play(removeAudio, 'remove');
    },
  };
})(window);
